import Workspace from "../../core/internal/workspace/Workspace"
import { Experiment, ExperimentConfig, HackleUser } from "../../core/internal/model/model"
import TargetMatcher from "../../core/internal/evaluation/match/TargetMatcher"
import { EvaluatorContext } from "../../core/internal/evaluation/evaluator/Evaluator"
import EvaluateRequest from "../../core/internal/evaluation/EvaluateRequest"

export class SplitUrlMatcher {
  constructor(private readonly targetMatcher: TargetMatcher) {}

  matches(workspace: Workspace, experiment: Experiment, user: HackleUser): boolean {
    // Config-model candidates carry the implementation type; remote candidates are pre-filtered
    // by the presence of split-url targets.
    if (experiment instanceof ExperimentConfig && experiment.implementationType !== "SPLIT_URL") return false
    if (!experiment.targetUrls) return false
    const { targetUrls } = experiment

    const request = SplitUrlEvaluateRequest.of(workspace, experiment, user)

    if (targetUrls.excludeTargets.length > 0) {
      if (this.targetMatcher.anyMatches(request, EvaluatorContext.create(), targetUrls.excludeTargets)) {
        return false
      }
    }

    return (
      targetUrls.includeTargets.length > 0 &&
      this.targetMatcher.anyMatches(request, EvaluatorContext.create(), targetUrls.includeTargets)
    )
  }
}

class SplitUrlEvaluateRequest implements EvaluateRequest {
  readonly record = false

  private constructor(readonly workspace: Workspace, readonly entity: Experiment, readonly user: HackleUser) {}

  toString(): string {
    return `SplitUrlEvaluateRequest(key=${this.entity.key})`
  }

  static of(workspace: Workspace, experiment: Experiment, user: HackleUser): SplitUrlEvaluateRequest {
    return new SplitUrlEvaluateRequest(workspace, experiment, user)
  }
}
